import { LOYALTY_TIER } from 'modules/loyalty/constants'

export default function isGoldTierLoyaltyUtil (tierName) {
  return tierName === LOYALTY_TIER.GOLD
}
